export enum BuildingTypes {
    HighRise = 28,
    LowRise = 34,
    Loft = 33,
    Townhouse = 29,
    Brownstone = 30,
    Walkup = 32,
    Office = 227,
    Retail = 228,
    Hotel = 31
}